import store from '../../store'

let role = 'leader'

export default {
  role,
  guard: () => store.getters['auth/isLeader'],
  items: [
    {
      label: 'Carico Prodotti',
      name: `Warehouses`,
      items: []
    },
    {
      label: 'Firma',
      name: `Presence`,
      items: []
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/navigator/leader.js